import { render, staticRenderFns } from "./LoanPieChart.vue?vue&type=template&id=0850c3f6&scoped=true"
import script from "./LoanPieChart.vue?vue&type=script&lang=js"
export * from "./LoanPieChart.vue?vue&type=script&lang=js"
import style0 from "./LoanPieChart.vue?vue&type=style&index=0&id=0850c3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0850c3f6",
  null
  
)

export default component.exports